module.exports = "../static/media/banner.daabc1de.png";